import { Grid, Typography, withStyles, Button, Avatar, Theme } from '@material-ui/core';
import React from 'react';
import moment from 'moment';
import { RouteLink } from 'components/Shared/RouteLink';
import { withLocale } from 'hocs/withLocale';
import routes from 'library/Routes';
import { ClassEventListViewProps, ClassEventListViewStyles } from '../../../types';

export const ClassEventListView = withLocale(
  withStyles(
    (theme: Theme): ClassEventListViewStyles => ({
      root: {
        padding: theme.spacing(2),
        borderBottom: `1px solid ${theme.palette.divider}`,
      },
      info: {},
      avatar: {
        width: theme.spacing(10),
        height: theme.spacing(10),
      },
      time: {},
      timeGrid: {
        paddingRight: theme.spacing(1),
      },
      title: {
        fontWeight: '900',
      },
    })
  )(
    class extends React.Component<ClassEventListViewProps> {
      render = (): JSX.Element => {
        const { onClick, showClientTag, classes, event, studio, translate } = this.props;
        const classInfo = event.classInfo;
        const eventObject = classInfo || event;
        const limit = eventObject ? eventObject.limit : null;
        const start = moment.utc(event.start);
        const end = moment.utc(start).add(eventObject.duration, 'minute').startOf('minute');

        const startDate = event.startDate && moment.utc(event.startDate).startOf('day');
        const endDate = event.endDate && moment.utc(event.endDate).endOf('day');

        let rangeStr = '';
        if (startDate || endDate) {
          rangeStr += '(';

          rangeStr += startDate ? startDate.format('DD MMM') : '∞';
          rangeStr += ' - ';
          rangeStr += endDate ? endDate.format('DD MMM') : '∞';

          rangeStr += ')';
        }

        let registrationExpired = Boolean(event.noSignUp);
        let sportsLeft: number | undefined;

        if (classInfo && !classInfo.private && eventObject.allowSelfSignUp) {
          if (limit) {
            sportsLeft = limit - event.registeredCount;
            if (sportsLeft < 1) {
              registrationExpired = true;
            }
          }
        } else {
          registrationExpired = true;
        }

        const renderLimit = (): JSX.Element | undefined => {
          if (registrationExpired) {
            return undefined;
          }

          let spotsInfo: string | undefined;

          if (classInfo) {
            if (limit) {
              if (sportsLeft && sportsLeft > 0) {
                spotsInfo = `😀${sportsLeft}/${limit}`;
              } else {
                spotsInfo = `😡${translate('studio.classBookedOut')}`;
              }
            }
          } else {
            if (limit) {
              spotsInfo = `Max. ${limit}`;
            }
          }

          return spotsInfo ? <Typography>{spotsInfo}</Typography> : undefined;
        };

        return (
          <Grid
            onClick={onClick ? () => onClick(event) : undefined}
            className={classes.root}
            container
            style={{ borderLeft: `2px solid ${event.color}` }}
          >
            <Grid item className={classes.timeGrid}>
              <Grid container spacing={1} direction="column">
                {event.teachers &&
                  event.teachers.map((teacher, index) => {
                    if (teacher.avatar) {
                      return (
                        <Grid item key={`teacher-avatar-${index}`}>
                          <Avatar src={teacher.avatar} className={classes.avatar} />
                        </Grid>
                      );
                    }
                    return null;
                  })}
                <Grid item>
                  <Typography className={classes.time} noWrap>
                    {start.format('HH:mm')} - {end.format('HH:mm')}
                    {rangeStr}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item className={classes.info}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  {event.showTitle && (
                    <Typography className={classes.title} noWrap variant="caption">
                      {event.title}
                    </Typography>
                  )}
                  {!event.showTitle && (
                    <Typography className={classes.title} noWrap variant="caption">
                      {event.billingTag}
                    </Typography>
                  )}

                  {showClientTag && event.clientTag && <Typography variant="subtitle2">#{event.clientTag}</Typography>}
                </Grid>
                {event.teachers &&
                  event.teachers.map((teacher, index) => (
                    <Grid item xs={12} key={`teacher-name-${index}`}>
                      <Typography>{teacher.name}</Typography>
                    </Grid>
                  ))}

                {renderLimit()}
                {!registrationExpired && classInfo && (
                  <Grid item xs={12}>
                    <Button
                      component={RouteLink}
                      target="_blank"
                      to={routes.getClassLink(studio, classInfo.groupId)}
                      color="secondary"
                      variant="outlined"
                    >
                      {translate('studio.classSignUp')}
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
        );
      };
    }
  )
);
